/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router';
import { IonPage, IonContent, IonSearchbar, IonList, IonFab, IonFabButton, IonIcon } from '@ionic/react'

import Toolbar from '../components/Toolbar';
import ItemWordSearch from '../components/ItemWordSearch';

import { add } from 'ionicons/icons';
import { Word } from '../models/Word';

import WordService from '../services/WordService';
import { ADD_WORD_ROUTER, DETAILS_WORD_ROUTER } from '../Routers';
import { Order } from 'models/Order';

const Words: React.FC = () => {
  const history = useHistory();

  const [sortBy, setSortBy] = useState('text')
  const [order, setOrder] = useState(Order.ASC)

  const [words, setWords] = useState<Word[]>([]);
  const [wordsSorted, setWordsSorted] = useState<Word[]>([]);

  const searchItem = (term?: string) => {
    const termFormatted = term?.trim()

    if (termFormatted) {
      const _filtered = words.filter(word => {
        return word.text.toLowerCase().includes(termFormatted.toLowerCase())
      });

      setWordsSorted(_filtered);
    } else {
      setWordsSorted(words)
    }
  }

  const addNewWord = () => {
    history.push(ADD_WORD_ROUTER)
  }

  const itemSelected = (word: Word) => {
    history.push(`${DETAILS_WORD_ROUTER}?wordId=${word.key}`);
  }

  const fetchWords = useCallback(async () => {
    WordService.getWords(sortBy, order).then(_words => {
      setWords(_words)
      setWordsSorted(_words);
    })
  }, [sortBy, order])

  useEffect(() => {
    fetchWords()
  }, [fetchWords])

  return (
    <IonPage>
      <Toolbar menuBtn={true} infoBtn={false} title={'Palavras'} />

      <IonContent>
        <IonSearchbar placeholder="Buscar palavra..." onIonChange={event => searchItem(event.detail.value)} />

        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonFabButton onClick={addNewWord}>
            <IonIcon icon={add} />
          </IonFabButton>
        </IonFab>

        <IonList>
          {wordsSorted.map((word, index) =>
            <ItemWordSearch key={index} word={word} onClick={() => itemSelected(word)} />
          )}
        </IonList>
      </IonContent>
    </IonPage>
  )
}

export default Words
